import { useEffect, useState } from 'react';

import type { FrapiTeaserItem } from '../../types/frapi-types.js';
import type { SortConfig } from '../layouts/front/sectionHelpers.js';

import { useSort } from './useSort.js';
import { console } from '../../../core/system/console/index.js';

export type UseManageSearchHook = {
  collection: FrapiTeaserItem[];
  page: number;
  handleNext: () => void;
  handleSort: (config: SortConfig) => void;
  sortConfig: SortConfig | null;
};

export const useManageSearch = (
  results: FrapiTeaserItem[],
  config: SortConfig | null,
  query: string,
): UseManageSearchHook => {
  const [page, setPage] = useState(1);
  const [extraResults, setExtraResults] = useState<FrapiTeaserItem[]>(results);

  const handleNext = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = new URL(`/api${query}`, window.location.origin);
      url.searchParams.set('page', page.toString());

      const raw = await fetch(url);
      const data = await raw.json();

      setExtraResults((prevData) => {
        const newData = data?.articles || data?.items || [];

        const url = new URL(location.href);
        const size = url.searchParams.get('size');
        const currentSize = size ? parseInt(size) : prevData.length;

        url.searchParams.set('size', currentSize + newData.length);
        window.history.pushState(null, '', url);

        return [...prevData, ...newData];
      });
    };

    if (page > 1) fetchData().catch((e) => console.error(e));
  }, [page, query]);

  const { sortedItems, handleSort, sortConfig } = useSort(
    [...extraResults],
    config,
  );

  return {
    collection: sortedItems,
    page,
    handleNext,
    handleSort,
    sortConfig,
  };
};
